import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import { FillingStationDeletedModel } from '../../../api/fillingstationdeleted/fillingstationdeleted';
import { FillingStationDeletedService } from '../../../api/fillingstationdeleted/fillingstationdeleted.service';

import { dragDropSortableServiceFactory } from 'ng2-dnd';
import { ThrowStmt } from '@angular/compiler';
declare var $: any;
declare var jQuery: any;
declare var swal: any;
@Component({
    selector: 'fillingstationdeleted-page',
    templateUrl: './fillingstationdeleted.html'
})
export class FillingStationDeletedComponent implements OnInit {
    fillingstationList: FillingStationDeletedModel[];
    fillingstationissueList: FillingStationDeletedModel[];
    fillingstation : FillingStationDeletedModel;
    progressPer :string = "0%";
    constructor(private fillingstationDeletedService: FillingStationDeletedService, private router: Router) {
    }
    ngOnInit() {
        if (localStorage.getItem('id_token') && (localStorage.getItem('type') == 'SUPERADMIN' || localStorage.getItem('type') == 'ADMIN' ||  localStorage.getItem('type') == 'GENEROSITY')) {
            this.progressPer = "0%";
            this.fillingstationDeletedService.allData().then(data => {
                this.progressPer = "100%";
                this.fillingstationList = data;
                this.progressTimeOut();
            });
        } else {
            this.router.navigate(['/']);
        }
    }
    progressTimeOut()
    {
        setTimeout(()=>
        { 
        this.progressPer = "0%"; 
        },200);
    }
    ExternalMapLocation(lati,longi)
    {
        window.open("https://maps.google.com/?q="+lati+","+longi, "_blank");
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/fillingstationdeleted/fillingstationdeleted.page.ts